// src/tenantloader/firebase.js - Tenant-aware Firebase wrapper
// Bridge between shared components and tenant-specific Firebase

import { loadTenantFirebase } from './TenantLoader';

const tenantFirebase = loadTenantFirebase();

export let auth = tenantFirebase.auth;
export let db = tenantFirebase.db;
export let storage = tenantFirebase.storage;
export default tenantFirebase.default;

export function switchToReviewFirebase() {
  const active = tenantFirebase.switchToReviewFirebase();
  auth = active.auth;
  db = active.db;
  storage = active.storage;
}

export function switchToAppFirebase() {
  const active = tenantFirebase.switchToAppFirebase();
  auth = active.auth;
  db = active.db;
  storage = active.storage;
}
